/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  // filters: the chat list's own filters, so the backend assigns exactly what the Unassigned tab shows.
  async assignUnassignedConversations({
    inboxId,
    status,
    assigneeId,
    teamId,
    labels,
    conversationType,
    conversationReadStatus,
  }) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/unassigned_conversations_assignment`,
      {
        filters: {
          inbox_id: inboxId,
          status,
          assignee_id: assigneeId,
          team_id: teamId,
          labels,
          conversation_type: conversationType,
          conversation_read_status: conversationReadStatus,
        },
      }
    );
  }

  async createOneClickConversations(payload) {
    const url = `/api/v1/accounts/${this.accountIdFromRoute}/create_one_click_conversations`;

    return axios.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new AccountAPI();
